export default "__VITE_ASSET__CVP$OPim__"